import { useEffect } from "react"

const Login = ({ login, config }) => {
    useEffect(() => {
        login(config)
    }, [login, config])

    return <p>Redirecting to login...</p>
}

export default Login
